import React from 'react';
import { Grid } from '@mui/material';
import { Button, Icons, InputAdornment, MenuItem, SelectField, Stack, TextField } from '@curves/ui-base';
import { ensureValidOptions } from '@Util/utils';

/**
 * 商品總覽搜尋列
 * - 關鍵字（商品名稱/SKU）、上下架狀態、第一層分類
 * - `options` 為商品選項（`categoryOptions`、`isEnabledOptions`）
 */
const ProductListSearchBar = ({ searchTextRef, isEnabledRef, categoryRef, searchParams, options = {} }) => {
    // 上下架下拉選項
    const enabledOptions = ensureValidOptions(options.isEnabledOptions);
    // 第一層分類下拉選項
    const categoryOptions = ensureValidOptions(options.categoryOptions).map((node) => ({ text: node.text, value: String(node.categoryID) }));

    return (
        <Grid container spacing={2}>
            <Grid item xs={4}>
                <TextField
                    label="搜尋商品"
                    ref={searchTextRef}
                    key={searchParams.searchText ?? ''}
                    defaultValue={searchParams.searchText}
                    inputProps={{ placeholder: '搜尋商品名稱/SKU' }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icons.Magnifier />
                            </InputAdornment>
                        ),
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={4}>
                <SelectField
                    ref={isEnabledRef}
                    key={`${String(searchParams.isEnabled ?? '')}-${enabledOptions.length}`}
                    label="上下架狀態"
                    defaultValue={searchParams.isEnabled ?? ''}
                    displayEmpty
                    fullWidth
                >
                    {enabledOptions.map(({ text, value }) => (
                        <MenuItem key={value} value={value}>
                            {text}
                        </MenuItem>
                    ))}
                </SelectField>
            </Grid>
            <Grid item xs={4}>
                <SelectField
                    ref={categoryRef}
                    key={`${String(searchParams.categoryID ?? '')}-${categoryOptions.length}`}
                    label="第一層分類"
                    defaultValue={searchParams.categoryID ?? ''}
                    displayEmpty
                    fullWidth
                >
                    {categoryOptions.map(({ text, value }) => (
                        <MenuItem key={value} value={value}>
                            {text}
                        </MenuItem>
                    ))}
                </SelectField>
            </Grid>
            <Grid item xs={12}>
                <Stack direction="row" justifyContent="end">
                    <Button variant="contained" color="primary" type="submit">
                        搜尋
                    </Button>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default ProductListSearchBar;
